import { tokens } from "../../theme";
import * as React from "react";
import * as CONSTANT from "../../constants/Constant";

import { MenuItem } from "@mui/material";
import {  Menu } from "@mui/material";
import dayjs, {  } from 'dayjs';
import MoreVertIcon from "@mui/icons-material/Attachment";

import {
  Box,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import SectionHeader from "../../components/SectionHeader";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import { DataGrid } from "@mui/x-data-grid";
import ConnectionStatus from "../../utils/ConnectionStatus";
import { SnackbarProvider, useSnackbar } from "notistack";
import UseOnlineStatus from "../../utils/UseOnlineStatus";
import {
  getFromLocalStorage,
  saveToLocalStorageJsonObject,
  getFromLocalStorageJsonObject,
} from "../../utils/localStorageUtils";
import CustomProgressDialog from "../../components/CustomProgressDialog";
import ShowErrorAlertDialog from "../../components/ErrorAlertDialog";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import {
  isAuthPageAtom,
  selectedBatchNo,
  showErrorAlertDialog,
} from "../../config/AppConfig";
import {
  ALERT,
  ERROR,
  ERROR_WHILE_FETCHING_DATA,
  NO_INTERNET_CONNECTION_FOUND,
  PROCESSING_PLEASE_WAIT,
  YOU_ARE_OFFLINE,
  YOU_ARE_ONLINE,
  LOADING_REPORT_NAMES_PLEASE_WAIT,
  LOADING_PLEASE_WAIT,
  ERROR_FOUND_DURING_API_CALL,
} from "../../constants/Strings";
import { initializeEncryption } from "../../services/AesGcmEncryption";
import DebugLog from "../../utils/DebugLog";
import {
  LOGIN_ID,
  MESSAGE_KEY,
  SESSION_ID,
  USER_ROLE,
  USER_NAME,
  SELECTED_PAYOUT_CYCLE_DATA,
} from "../../constants/LocalStorageKeyValuePairString";
import {
  generateRandomId,
  generateRequestId,
} from "../../utils/RequestIdGenerator";
import { ApiErrorCode, ApiType } from "../../services/ApiTags";
import NoDataFound from "../../components/NoDataFound";

import CustomButton from "../../components/CustomButton";
import PriceFormatter, { formatPrice } from "../../utils/PriceFormatter";

import { getButtonVisibilityData } from "../../utils/GetButtonVisibilityAsPerLoginResponse";
import { IncentivesActionsConfirmationDialog } from "../../components/IncentivesActionsConfirmationDialog";
import HighlightStats from "../../components/HighlightStats";
import useAxiosHookV2 from "../../hooks/UseAxiosV2";
import useAxiosHookV2FileUpload from "../../hooks/UseAxiosV2FileUpload";
import { DownloadPayoutOnHoldReportNameSelectionDialog } from "../../components/DownloadPayoutOnHoldReportNameSelectionDialog";
import UseAxiosV1Api from "../../hooks/UseAxiosV1Api";
import { downloadPdfViewerData, getAttachmentInfo } from "../../services/ApiService";
import PdfViewerDialog from "../exclusion/PdfViewerDialog";
import FileDialog from "../../components/FileDialog";

// Filter Configurations to be passed to SearchBarFilter in SectionHeader
const filterProps = [
  {
      keyValue: 'Cycle Name',
      displayName: 'Name',
      paramName: 'cycleName',
      isDateFilter: false,
      isSearchBarDropdown: false,
      searchBarDropdownOptions: [],
  },
  {
      keyValue: 'status',
      displayName: 'Status',
      paramName: 'status',
      isDateFilter: false,
      isSearchBarDropdown: true,
      searchBarDropdownOptions: [
        "Pending Review",
        "Pending Approval",
        "Completed",
        "Hold",
        "Cancel",
        "Release Approval"
      ],
  },
  {
      keyValue: 'Cutoff Date',
      displayName: 'Cutoff',
      paramName: 'cutoffDate',
      isDateFilter: true,
      isSearchBarDropdown: false,
      searchBarDropdownOptions: [],
  },
  {
      keyValue: 'Payout Date',
      displayName: 'Payout By',
      paramName: 'payoutDate',
      isDateFilter: true,
      isSearchBarDropdown: false,
      searchBarDropdownOptions: [],
  },
];

const OnHoldPayoutCycles = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isNetworkConnectionAvailable = UseOnlineStatus();

  const navigate = useNavigate();
  const location = useLocation();
  let selectedPayoutCycle = location.state;

  const [, setAuthStatus] = useAtom(isAuthPageAtom);
  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);
  const [batchNoForDownload, setBatchNoForDownload] = useAtom(selectedBatchNo);

  const [open, setOpen] = useState(false);
  
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");
  const [getProgressbarText, setProgressbarText] = useState("");

  const [holdType, setHoldType] = useState("");
  const [onHoldSummary, setOnHoldSummary] = useState([]);

  const [gridHeight, setGridHeight] = useState(108); // Default height
  const [rowsPerPage, setRowsPerPage] = useState(0); // Used to set the height of the grid

  // pagination
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 15,
    page: 0,
  });
  const [pageSize, setPageSize] = useState(15);
  const [totalNoOfRows, setTotalNoOfRows] = useState(0);
  const [totalNoOfPages, setTotalNoOfPages] = useState(0);

  const [selectedRows, setSelectedRows] = React.useState([]);
  const [userRole, setUserRole] = useState([]);

  // button visibility
  const [requestReleaseButtonVisible, setRequestReleaseButton] =
    useState(false);
  const [downloadButtonVisible, setDownlaodButton] = useState(false);
  const [releaseButtonVisibility, setReleaseButton] = useState(false);
  const [cancelButtonButtonVisibility, setCancelButton] = useState(false);
  const [commentButtonVisibility, setCommentVisibility] = useState(false);
  const [rejectButtonVisibility, setRejectButton] = useState(false);

  // actions confirmation dialog
  const [dialogOpen, setDialogOpen] = useState(false);
  const [clickedButtonType, setClickedButtonType] = useState("");
  const [batchNo, setBatchNo] = useState("");
  const [dialogTitle, setDialogTitle] = useState("");

  const [onHoldHeaderSummary, setOnHoldHeaderSummary] = useState([]);

  const { apiCallError, showProgressBar, fetchData } = useAxiosHookV2();
  const {
    apiCallError: headerApiCallError,
    showProgressBar: showHeaderProgressBar,
    fetchData: fetchHeaderSummaryData,
  } = useAxiosHookV2();

  const [downloadFileDialogOpen, setDownloadFileDialogOpen] = useState(false);
  const {
    dataResponseFileUpload,
    apiCallErrorFileUpload,
    showProgressBarFileUpload,
    fetchDataFileUpload,
  } = useAxiosHookV2FileUpload();
 


  const [actionButtonVisibility, setActionButtonVisibility] = useState(false);

  const { dataV1, errorV1, showProgressBarV1, fetchDataV1 } = UseAxiosV1Api();
  const [reportNameOptions, setReportNameOptions] = useState([]);
  const [reportNamesValue, setReportNamesValue] = useState([]);
  const [downloadType, setDownloadType] = useState("");

  // filter and search
  const [selectedFilter, setSelectedFilter] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  // sort model
  const [sortModel, setSortModel] = useState([]);
  const hasInitializedSortModel = React.useRef(false);
  let blob;
  let filename;
  let url;

  const [openFileDialog, setFileDialogOpen] = useState(false);
  const [files, setFiles] = useState([]);
  const [pdfData, setPdfData] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [commentData, setComment] = useState("");


  useEffect(() => {
    if (showProgressBarV1) {
        setProgressbarText(LOADING_REPORT_NAMES_PLEASE_WAIT);
        setLoading(true);
    } else {
       setLoading(false);
    }
  }, [showProgressBarV1]);




  function getReportNamesFromApi(batchNo) {
    try {
      
        const requestObject = {
            batchNo: batchNo,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_REPORT_NAMES_LIST
        ).then((encryptedContentData) => {
         
          fetchDataV1(process.env.REACT_APP_REPORT_NAMES_API_URL,ApiType.GET_REPORT_NAMES_LIST,ApiType.POST_METHOD, encryptedContentData, {}, (data) => {
            if (data !== null) {
              if (
                data.result.reportNames.length > 0
              ) {
                setReportNameOptions(
                  data.result.reportNames.map(
                    (item) => item.reportName
                  )
                );
                setReportNamesValue(
                  data.result.reportNames
                );
              } else {
                showErrorAlert(
                  ALERT,
                  CONSTANT.ERROR_IN_LOADING_REPORT_NAMES
                );
              }

            }
          });

        
        });
      
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  const getReportName = (type) => {
    if(selectedRows.length>0){
    setDownloadType(type)
    getReportNamesFromApi(batchNo)
    }else if(selectedRows.length===0){
      alert("Please choose a row for file download!")
    }else{
      alert("Selection of only one row at one time is allowed!")
    }
  }

  useEffect(() => {
    if(reportNameOptions.length>0){
      openDownloadOptionsDialog(downloadType)
    }
   
  }, [reportNameOptions]);

  // sorting handling 
  useEffect(() => {
    if (!hasInitializedSortModel.current) {
      hasInitializedSortModel.current = true;
      return;
    }

    checkSelectedCycleHoldSummary();

    getPayoutTransactionType(
      selectedPayoutCycle?.holdType,
      selectedPayoutCycle?.companyCode,
      paginationModel.page,
      paginationModel.pageSize,
      selectedFilter,
      searchQuery
    );
  }, [sortModel]);

  useEffect(() => {

    getUserRole();
    checkSelectedCycleHoldSummary();
    updateButtonVisibility();

    if(selectedPayoutCycle?.holdType!=="e-Inv Missing"){
      setActionButtonVisibility(true)
    }else{
      setActionButtonVisibility(false)
    }

    setHoldType(selectedPayoutCycle?.holdType);

    if (selectedPayoutCycle?.holdType) {
      callApi(
        selectedPayoutCycle?.holdType,
        selectedPayoutCycle?.companyCode,
      );
      getDealerHeaderSummary(
        selectedPayoutCycle?.holdType,
        selectedPayoutCycle?.companyCode,
      );
    } else {
      showErrorAlert(ERROR, "Invalid Cycle data");
    }
  }, []);

  

  useEffect(() => {

    getDataGridHeight();

    showNoInternetSnackBar();

    navigate(blockNavigation);
  }, [isNetworkConnectionAvailable, enqueueSnackbar, navigate, rowsPerPage]);

  async function callApi(holdType,companyCode) {

    try {
     
      getPayoutTransactionType(holdType,companyCode);
    } catch (error) {
      handleError(error);
    }

  }
  function getUserRole() {
    setUserRole(getFromLocalStorage(USER_ROLE));
  }
  // increase - decrease list layout height on available list itmes count
  function getDataGridHeight() {
    // Calculate the total height required for the grid
    const headerHeight = 60; // Height of header row
    const rowHeight = 60; // Height of each data row
    let rowCount = 0;
    if (rowsPerPage <= pageSize) {
      rowCount = rowsPerPage; // Total number of data rows
    } else {
      rowCount = pageSize; // Total number of data rows
    }

    const totalHeight = headerHeight + rowCount * rowHeight;

    // Set the grid height
    setGridHeight(totalHeight);
  }

  const openDownloadOptionsDialog = (type) => {
    if (isNetworkConnectionAvailable) {
      if(selectedRows.length===1){
        let title = "";
        if (type === "Download") {
          title = "Download";
        }
        setClickedButtonType(type);
        setDialogTitle(title);
        setDownloadFileDialogOpen(true);
      }else{
       // showErrorAlert(ALERT,"Please choose only one row!")
        alert("Please choose only one row!")
      }
  
  } else {
    showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
  }
  };

  const handleFileDownloadSubmit = (fileType, type, startDate, endDate) => {
     // downloadWithholdingReport(fileType, startDate, endDate);
    
  };


  const handleFileDownloadDialogClose = () => {
    setDownloadFileDialogOpen(false);
  };

  function checkSelectedCycleHoldSummary() {
    // If selectedPayoutCycle is not in the location state (e.g., after a page refresh),
    // try to retrieve it from localStorage
    if (!selectedPayoutCycle) {
      const storedData = getFromLocalStorageJsonObject(
        SELECTED_PAYOUT_CYCLE_DATA,
        JSON.stringify(selectedPayoutCycle)
      );
      selectedPayoutCycle = storedData ? JSON.parse(storedData) : null;
    } else {
      // If payoutRowSelected is in the location state, store it in localStorage
      saveToLocalStorageJsonObject(
        SELECTED_PAYOUT_CYCLE_DATA,
        JSON.stringify(selectedPayoutCycle)
      );
    }
  }

  const updateButtonVisibility = () => {
    const actionButtonList = getButtonVisibilityData("Incentive", "On Hold");
    if (actionButtonList) {
      actionButtonList.forEach((items, index) => {
        if (items.buttonName === "DOWNLOAD") {
          setDownlaodButton(true);
        } else if (items.buttonName === "REQUEST RELEASE") {
          setRequestReleaseButton(true);
        } else if (items.buttonName === "RELEASE") {
          setReleaseButton(true);
        } else if (items.buttonName === "CANCEL") {
          setCancelButton(true);
        } else if (items.buttonName === "REJECT") {
          setRejectButton(true);
        }else if (items.buttonName === "COMMENT") {
          setCommentVisibility(true);
        }
      });
    }
  };

  /******* Confirmation Dialog Methods ***********/
  const handleDialogOpen = (type) => {
     if (selectedRows.length === 0) {
      showErrorAlert(ALERT, "Please select some rows first!");
    } else {
      let title = "";
      if (type === "Cancel") {
        title = "Cancel";
      } else if (type === "Release") {
        title = "Release";
      } else if (type === "Request Release") {
        title = "Request Release";
      }
      setClickedButtonType(type);
      setDialogTitle(title);
      setDialogOpen(true);
    }
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleSubmit = (file, comment, type, selectedDate) => {
    let formattedDate = selectedDate;
    if (type === "Cancel") {
      formattedDate = null;
    }
    dialogResponseRecieved(file, comment, type, formattedDate);
  };

  const dialogResponseRecieved = (file, comment, type, date) => {
     if(date===null){
      const today = dayjs();//2024-07-24
      date = today.format('YYYY-MM-DD')
    }
    const selectedData = onHoldSummary.filter((row) =>
      selectedRows.includes(row.id)
    );

   
    let extractBatchNo = []
    extractBatchNo = selectedData.map(item => item.batchNo+"");          
    

    if (file) {
      const fileNameWithoutExtension = file.name
        .split(".")
        .slice(0, -1)
        .join(".");

      handleFileChange(
        file,
        extractBatchNo,
        fileNameWithoutExtension,
        comment,
        type,
        date
      );
      return;
    } else {
      const requestData = {
        holdType: holdType,
        batchNos: extractBatchNo,
        remark: comment,
        selectedDate: date,
      };

      if (type === "Cancel") {
        requestOnHoldCancel(requestData, "");
      } else if (type === "Release") {
        releaseOnHoldApiRequest(requestData, "");
      } else if (type === "Request Release") {
        requestReleaseOnHoldApiCall(requestData, "");
      }else if (type === "Reject") {
        rejectOnHoldApiRequest(requestData, "");
      }
      DebugLog("onHold Request Data =======" + JSON.stringify(requestData));
    }
  };

 

  const handleFileChange = async (
    selectedFile,
    extractBatchNo,
    fileNameWithoutExtension,
    comment,
    type,
    date
  ) => {
    try {
      const fileBase64Encoding = await getBase64(selectedFile);
      // Extract only the Base64 data
      const base64Only = fileBase64Encoding.split(",")[1];
      //const fileByteArray = await getByteArray(selectedFile);
      const requestData = {
        holdType: holdType,
        batchNos: extractBatchNo,
        fileName: fileNameWithoutExtension,
        fileType: selectedFile.type,
        remark: comment,
        selectedDate: date,
      };
     

      if (type === "Cancel") {
        requestOnHoldCancel(requestData, base64Only);
      } else if (type === "Release") {
        releaseOnHoldApiRequest(requestData, base64Only);
      } else if (type === "Request Release") {
        requestReleaseOnHoldApiCall(requestData, base64Only);
      }else if (type === "Reject") {
        rejectOnHoldApiRequest(requestData, base64Only);
      }

      // return base64String;
    } catch (error) {
      console.error("Error converting file to byte array:", error);
    }
  };

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };
const rejectOnHoldApiRequest = (onHoldCancelRequestData, fileBase64Encoding) => {
      try {
        if (isNetworkConnectionAvailable) {
          initializeEncryption(
            onHoldCancelRequestData,
            getFromLocalStorage(MESSAGE_KEY),
            ApiType.REJECT_ON_HOLD_CYCLE
          ).then((encryptedContentData) => {
            let requestData;
            if (fileBase64Encoding !== null && fileBase64Encoding !== "") {
              requestData = {
                requestId: generateRequestId(),
                loginId: getFromLocalStorage(LOGIN_ID),
                sessionId: getFromLocalStorage(SESSION_ID),
                contentData: encryptedContentData,
                loginUserName: getFromLocalStorage(USER_NAME),
                fileContent: fileBase64Encoding,
              };
            } else {
              requestData = {
                requestId: generateRequestId(),
                loginId: getFromLocalStorage(LOGIN_ID),
                sessionId: getFromLocalStorage(SESSION_ID),
                contentData: encryptedContentData,
                loginUserName: getFromLocalStorage(USER_NAME),
              };
            }
  
            fetchDataFileUpload(
              process.env.REACT_APP_REJECT_ON_HOLD_CYCLE_API_URL,
              ApiType.REJECT_ON_HOLD_CYCLE,
              ApiType.POST_METHOD,
              requestData,
              {},
              (data) => {
                if (data !== null) {
                  if (data.responseCode === "0") {
                    navigate("/OnHoldActionItemsSuccess", {
                      state: { data: data.result, type: 3 },
                    });
                  }
                }
              }
            );
          });
        } else {
          showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
        }
      } catch (error) {
        const message = error.response != null ? error.response : error.message;
        showErrorAlert(
          error.message,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
        );
      }
    };

    
  const releaseOnHoldApiRequest = (
    onHoldCancelRequestData,
    fileBase64Encoding
  ) => {
    try {
      if (isNetworkConnectionAvailable) {
        initializeEncryption(
          onHoldCancelRequestData,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.ON_HOLD_RELEASE_CYCLE
        ).then((encryptedContentData) => {
          let requestData;
          if (fileBase64Encoding !== null && fileBase64Encoding !== "") {
            requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              contentData: encryptedContentData,
              loginUserName: getFromLocalStorage(USER_NAME),
              fileContent: fileBase64Encoding,
            };
          } else {
            requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              contentData: encryptedContentData,
              loginUserName: getFromLocalStorage(USER_NAME),
            };
          }

          fetchDataFileUpload(
            process.env.REACT_APP_RELEASE_ON_HOLD_CYCLE_API_URL,
            ApiType.ON_HOLD_RELEASE_CYCLE,
            ApiType.POST_METHOD,
            requestData,
            {},
            (data) => {
              if (data !== null) {
                if (data.responseCode === "0") {
                  navigate("/OnHoldActionItemsSuccess", {
                    state: { data: data.result, type: 0 },
                  });
                }
              }
            }
          );
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
    
  };

  const requestOnHoldCancel = (onHoldCancelRequestData, fileBase64Encoding) => {
    try {
      if (isNetworkConnectionAvailable) {
        initializeEncryption(
          onHoldCancelRequestData,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.ON_HOLD_CANCEL_CYCLE
        ).then((encryptedContentData) => {
          let requestData;
          if (fileBase64Encoding !== null && fileBase64Encoding !== "") {
            requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              contentData: encryptedContentData,
              loginUserName: getFromLocalStorage(USER_NAME),
              fileContent: fileBase64Encoding,
            };
          } else {
            requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              contentData: encryptedContentData,
              loginUserName: getFromLocalStorage(USER_NAME),
            };
          }

          fetchDataFileUpload(
            process.env.REACT_APP_CANCEL_ON_HOLD_CYCLE_API_URL,
            ApiType.ON_HOLD_CANCEL_CYCLE,
            ApiType.POST_METHOD,
            requestData,
            {},
            (data) => {
              if (data !== null) {
                if (data.responseCode === "0") {
                  navigate("/OnHoldActionItemsSuccess", {
                    state: { data: data.result, type: 1 },
                  });
                }
              }
            }
          );
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }

  };

  const requestReleaseOnHoldApiCall = (
    onHoldCancelRequestData,
    fileBase64Encoding
  ) => {
    try {
      if (isNetworkConnectionAvailable) {
        initializeEncryption(
          onHoldCancelRequestData,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.ON_HOLD_REQUEST_RELEASE_CYCLE
        ).then((encryptedContentData) => {
          let requestData;
          if (fileBase64Encoding !== null && fileBase64Encoding !== "") {
            requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              contentData: encryptedContentData,
              loginUserName: getFromLocalStorage(USER_NAME),
              fileContent: fileBase64Encoding,
            };
          } else {
            requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              contentData: encryptedContentData,
              loginUserName: getFromLocalStorage(USER_NAME),
            };
          }

          fetchDataFileUpload(
            process.env.REACT_APP_REQUEST_RELEASE_ON_HOLD_CYCLE_API_URL,
            ApiType.ON_HOLD_REQUEST_RELEASE_CYCLE,
            ApiType.POST_METHOD,
            requestData,
            {},
            (data) => {
              if (data !== null) {
                if (data.responseCode === "0") {
                  navigate("/OnHoldActionItemsSuccess", {
                    state: { data: data.result, type: 2 },
                  });
                }
              }
            }
          );
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }

  };



  /********  Pagination Methods ***********/
  const handlePageJump = (event) => {
    const newPage = parseInt(event.target.value, 10) - 1;
    setPaginationModel({ pageSize: pageSize, page: newPage });
    checkSelectedCycleHoldSummary();

    getPayoutTransactionType(
      selectedPayoutCycle?.holdType,
      selectedPayoutCycle?.companyCode,
      newPage,
      paginationModel.pageSize
    );
  };

  const handlePageChange = (newPage) => {
    setPaginationModel({ pageSize: pageSize, page: newPage });
    checkSelectedCycleHoldSummary();

    getPayoutTransactionType(
      selectedPayoutCycle?.holdType,
      selectedPayoutCycle?.companyCode,
      newPage,
      paginationModel.pageSize,
      selectedFilter,
      searchQuery
    );
  };

  const handlePageSizeChange = (newPageSize) => {
    // keep pageSize in sync with the paginationModel
    setPageSize(newPageSize);
    setPaginationModel({ pageSize: newPageSize, page: 0 });
    checkSelectedCycleHoldSummary();

    // call api with new page size and start from page 0.
    getPayoutTransactionType(
      selectedPayoutCycle?.holdType,
      selectedPayoutCycle?.companyCode,
      0,
      newPageSize
    );
  };

  const handleSelectionChange = (newSelection) => {
    setSelectedRows(newSelection);
    const selectedRowData = onHoldSummary.filter((row) =>
      newSelection.includes(row.id)
    );
    if(newSelection.length>0 && newSelection.length<2){
      setBatchNoForDownload(selectedRowData[0].batchN)
      setBatchNo(selectedRowData[0].batchNo)
    }
   
  };

  const resetSelection = () => {
    setSelectedRows([]);
  };


  function getDealerHeaderSummary(holdType,companyCode) {
    try {
      if (isNetworkConnectionAvailable) {
        const requestObject = {
          holdType: holdType,
          companyCode:companyCode,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.ON_HOLD_DYNAMIC_HEADER_SUMMARY
        ).then((encryptedContentData) => {
          fetchHeaderSummaryData(
            process.env.REACT_APP_DYNAMIC_HEADER_API_URL,
            ApiType.ON_HOLD_DYNAMIC_HEADER_SUMMARY,
            ApiType.POST_METHOD,
            encryptedContentData,
            {},
            (data) => {
              if (data !== null) {
                setOnHoldHeaderSummary(data.result);
              }
            }
          );
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + message
      );
    }
  }



  useEffect(() => {
    if (showProgressBarFileUpload) {
      setProgressbarText(PROCESSING_PLEASE_WAIT);
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [showProgressBarFileUpload]);


  

 

  useEffect(() => {
    if (errorV1) {
      if(errorV1.message!==null && errorV1.message !== undefined && errorV1.message===ApiErrorCode.NETWORK_ERROR){
        showErrorAlert(
          ERROR,
          errorV1.message
        );
      }
      else
        if (errorV1.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
          alert(errorV1.data.displayErrorMessage)
          navigate(CONSTANT.LOGIN)
        }else{
        const message =
        errorV1.data !== null &&  errorV1.data.displayErrorMessage!==null ? errorV1.data.displayErrorMessage : ERROR_WHILE_FETCHING_DATA;
        showErrorAlert(
          ERROR,
          "/reports/getPayoutReportNames Api error: " +message +" Batch No"+batchNo
        );
        }
      
      //handleClose();
    }
  }, [errorV1]);


  useEffect(() => {
    if (apiCallErrorFileUpload) {
      if(apiCallErrorFileUpload.message!==null && apiCallErrorFileUpload.message !== undefined && apiCallErrorFileUpload.message===ApiErrorCode.NETWORK_ERROR){
        showErrorAlert(
          ERROR,
          apiCallErrorFileUpload.message
        );
      }
      else
        if (apiCallErrorFileUpload.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
          alert(apiCallErrorFileUpload.data.displayErrorMessage)
          navigate(CONSTANT.LOGIN)
        }else{
        const message =
        apiCallErrorFileUpload.data !== null  &&  apiCallErrorFileUpload.data.displayErrorMessage!==null ? apiCallErrorFileUpload.data.displayErrorMessage : apiCallErrorFileUpload.message;
        showErrorAlert(
          ERROR,
          ERROR_WHILE_FETCHING_DATA+ JSON.stringify(message)
        );
        }
      
    }
  }, [apiCallErrorFileUpload]);

  
  useEffect(() => {
    const error = apiCallError || headerApiCallError;
    if (error) {
      if(error.message!==null && error.message !== undefined && error.message===ApiErrorCode.NETWORK_ERROR){
        showErrorAlert(
          ERROR,
          error.message
        );
      }
      else
        if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
          alert(error.data.displayErrorMessage)
          navigate(CONSTANT.LOGIN)
        }else{
        const message =
        error.data !== null  &&  error.data.displayErrorMessage!==null ? error.data.displayErrorMessage : error.message;
        showErrorAlert(
          ERROR,
          ERROR_WHILE_FETCHING_DATA+ JSON.stringify(message)
        );
        }
      
    }
  }, [apiCallError, headerApiCallError]);





  useEffect(() => {
    if (showProgressBar || showHeaderProgressBar) {
      setProgressbarText(PROCESSING_PLEASE_WAIT);
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [showProgressBar, showHeaderProgressBar]);

  async function getPayoutTransactionType(
    holdType,
    companyCode, 
    pageNo, 
    pageSize,
    selectedFilter, 
    searchQuery
  ) {
    try {
      if (isNetworkConnectionAvailable) {
        let requestObject = createRequestObject(
          holdType,
          companyCode,
          pageNo,
          pageSize,
          selectedFilter,
          searchQuery
        );
       

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_PAYOUT_SUMMARY_DEALER
        ).then((encryptedContentData) => {
          fetchData(
            process.env.REACT_APP_DASHBOARD_ON_HOLD_API_URL,
            ApiType.GET_PAYOUT_SUMMARY_DEALER,
            ApiType.POST_METHOD,
            encryptedContentData,
            {},
            (data) => {
              if (data !== null) {
                const responseData = data.result.content.map((row) => ({
                  ...row,
                  id: generateRandomId(),
                }));
                setOnHoldSummary(responseData);
                setRowsPerPage(data.result.content.length);
                setTotalNoOfRows(data.result.totalElements);
                setTotalNoOfPages(data.result.totalPages);
              }
            }
          );
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }

  }

  // Create Request Object for API call for table data
  function createRequestObject(holdType, companyCode, pageNumber, pageSize, selectedFilter, filterValue) {
    let requestObject = {
      holdType: holdType,
      pageNumber: pageNumber,
      pageSize: pageSize,
    };

    if(companyCode!==null && companyCode!==undefined && companyCode!=="" && companyCode!=="undefined"){
      requestObject.companyCode = companyCode;
    }

    // Set the appropriate field based on filterCriteria
    if (selectedFilter != null && selectedFilter != undefined && selectedFilter != "" && selectedFilter.paramName != "") {
      if (filterValue != null && filterValue != undefined && filterValue != "") {
        requestObject[selectedFilter] = filterValue;
      }
    }

    // sorting
    try{
      if (sortModel.length > 0) {
        // set sortProperty according to the field
        switch (sortModel[0].field) {
          case "displayName":
            requestObject.sortProperty = "CYCLE_NAME";
            break;
          case "payoutStatus":
            requestObject.sortProperty = "STATUS";
            break;
          case "cutOffDate":
            requestObject.sortProperty = "CUT_OFF";
            break;
          case "payOutDate":
            requestObject.sortProperty = "PAYOUT_BY";
            break;
          default:
            break;
        }

        // set the sort order
        requestObject.sortOrder = sortModel[0].sort.toString().toUpperCase();
      } 
    } catch (error) {
      DebugLog("Error in sorting: " + error);
      requestObject.sortProperty = null;
      requestObject.sortOrder = null;
    }

    return requestObject;
  }

  function blockNavigation(location, action) {
    // Block navigation if action is "pop", which indicates back/forward button press
    if (action === "pop") {
      // Optionally, you can show a message to the user before blocking navigation
      alert("Back button is disabled.");
      return false;
    }
    return true; // Allow navigation for other actions like "push" or "replace"
  }

  // search & filter handler
  const handleSearch = (filterParam, searchQuery) => {
    setSelectedFilter(filterParam);
    setSearchQuery(searchQuery);

    setPaginationModel({ pageSize: pageSize, page: 0 });
    checkSelectedCycleHoldSummary();

    getPayoutTransactionType(
      selectedPayoutCycle?.holdType,
      selectedPayoutCycle?.companyCode,
      0,
      paginationModel.pageSize,
      filterParam,
      searchQuery
    );
  }

  // handle error code reusable block
  function handleError(error) {
    setLoading(false);

    if (error.message === NO_INTERNET_CONNECTION_FOUND) {
      // Handle no internet connection error
      showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      return;
    }

    const errorCode = error.data?.errorCode;
    var errorMessage =
      error.response != null ? error.displayErrorMessage : "Unknown";
    if (error.data?.displayErrorMessage) {
      errorMessage = error.data.displayErrorMessage;
    }

    const errorActions = {
      [ApiErrorCode.SESSION_EXPIRED]: () => navigate(CONSTANT.LOGIN),
      [ApiErrorCode.SESSION_ID_NOT_FOUND]: () => navigate("/"),
      default: () =>
        showErrorAlert(
          error.message,
          ERROR_WHILE_FETCHING_DATA +errorMessage
        ),
    };

    (errorActions[errorCode] || errorActions.default)();
  }

  useEffect(() => {
    if(content!==null && content!=="" ){
     // setErrorDialog(true);
    }else{
      setErrorDialog(false);
    }
  }, [content]);


  function showErrorAlert(title, data) {
    try {
      DebugLog("error.data=====" + data);
      setError("");
      setLoading(false);

      setTitle(title);
      setContent(data);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }

  const showNoInternetSnackBar = () => {
    if (isNetworkConnectionAvailable) {
      enqueueSnackbar(YOU_ARE_ONLINE);
    } else {
      enqueueSnackbar(YOU_ARE_OFFLINE, {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
  };


 
/***** Navigation *******/
const handleBackClicked = () => {
  checkSelectedCycleHoldSummary();
 
  if(selectedPayoutCycle.rootStartPageSelectedColumn==="payoutCycleCount" ){
    if(selectedPayoutCycle.flowFrom ===CONSTANT.FINANCE_DASHBOARD){
      navigate(CONSTANT.FINANCE_DASHBOARD);
    }else{
      navigate(CONSTANT.ON_HOLD_ROUTE);
    }
  } else {
    navigate(CONSTANT.PAYOUT_DEALER_SUMMARY_ROUTE);
  }
 
};



  const handleRowClick = (params) => {

    if (params.field === '__check__') {
      // Skip handling when the checkbox is clicked
      return;
    }

    if (params.field !== "actions") {
    checkSelectedCycleHoldSummary();

    if(selectedPayoutCycle.rootStartPageSelectedColumn==="dealerCount"){
   navigate(CONSTANT.ON_HOLD_DEALERS_ROUTE, {
    state: {
      holdType:selectedPayoutCycle.holdType,
      companyCode:selectedPayoutCycle.companyCode,
      batchNo: params.row.batchNo,
      version: params.row.version,
      displayName: params.row.displayName,
      commissionType: params.row.commissionType,
      flowFrom: selectedPayoutCycle.flowStartedFrom,
      rootStartPageSelectedColumn:selectedPayoutCycle.rootStartPageSelectedColumn,
    },
  });
    } else {
       navigate(CONSTANT.PAYOUT_DEALER_SUMMARY_ROUTE, {
    state: {
      holdType:selectedPayoutCycle.holdType,
          batchNo: params.row.batchNo,
          version: params.row.version,
          displayName: params.row.displayName,
          commissionType: params.row.commissionType,
          flowFrom: selectedPayoutCycle.flowStartedFrom,
      rootStartPageSelectedColumn:selectedPayoutCycle.rootStartPageSelectedColumn,
    },
  });
    }
  }
  };

  function getAttachmentDetails(referenceId) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = {
          attachmentType: "ON_HOLD_AND_PAYOUT_SERVICE",
          reference: referenceId,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_ATTACHMENT_INFO
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            contentData: encryptedContentData,
          };

          getAttachmentInfo(requestData)
            .then((response) => {
              if (response.data.result.attachments !== null) {
                setFiles(response.data.result.attachments);
                setFileDialogOpen(true);
              } else {
                showErrorAlert(ALERT, "No Attachment Found!");
              }

              setLoading(false);
            })
            .catch((error) => {
              setLoading(false);
              if (
                error !== null &&
                error !== undefined &&
                error.data !== null &&
                error.data !== undefined &&
                error.data.errorCode != null &&
                error.data.errorCode !== undefined &&
                error.data.errorCode === ApiErrorCode.SESSION_EXPIRED
              ) {
                navigate(CONSTANT.LOGIN);
              } else if (
                error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND
              ) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.data != null
                    ? error.data.displayErrorMessage
                    : "Unknown";

                if (message)
                  showErrorAlert(
                    error.message,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }
  
  const MoreOptionsButton = ({ row }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
  
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleClose = () => {
      setAnchorEl(null);
    };
  
    const handleOptionClick = (option, event) => {
      event.stopPropagation();
      DebugLog(`Option ${option} clicked` + JSON.stringify(row));
      getAttachmentDetails(row);
      handleClose();
    };
  
    return (
      <>
        <IconButton onClick={handleClick}>
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          onClick={(event) => event.stopPropagation()} // Prevent row click even inside the menu
        >
          <MenuItem onClick={(event) => handleOptionClick("Download", event)}>
            Get Attachments Details
          </MenuItem>
          {/* <MenuItem onClick={(event) => handleOptionClick("View", event)}>
            View Attachment
          </MenuItem> */}
        </Menu>
      </>
    );
  };


  const CurrencyCellRenderer = ({ value }) => {
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        {/* <AttachMoneyIcon fontSize="small" /> */}
        {/* <span>RM</span>  */}
        {/* Malaysian Ringgit symbol */}
        <span style={{ marginLeft: "4px" }}>
          {" "}
          <PriceFormatter price={value} />
        </span>
      </div>
    );
  };
  
  
  
   const onHoldPayoutCyclesColumnHeader = [
    {
      field: "id",
      filterable: false,
      headerName: "ID",
      flex: 0.5,
      hide: true,
      headerAlign: "left",
    },
    {
      field: "batchNo",
      filterable: false,
      headerName: "BATCH NO.",
      flex: 0.5,
      hide: true,
      headerAlign: "left",
      sortable: false,
    },
    {
      field: "version",
      filterable: false,
      headerName: "VERSION",
      flex: 0.5,
      hide: true,
      headerAlign: "left",
      sortable: false,
    },
    {
      field: "displayName",
      flex: 1.2,
      headerName: "NAME",
      headerClassName: (params) =>
        params.field === "commissionType" ? "bold-header-style" : null,
      headerAlign: "left",
      cellClassName: "bold-column--cell",
    },
    {
      field: "payoutStatus",
      headerName: "STATUS",
      flex: 0.5,
      headerAlign: "left",
      cellClassName: "bold-column--cell",
      headerClassName: (params) =>
        params.field === "payoutStatus" ? "bold-header-style" : null,
      renderCell: (params) => {
        const getStatusColor = (status) => {
          switch (status) {
            case 'Release Approval':
              return 'green';
            case 'inactive':
              return 'red';
            case 'Hold':
              return 'orange';
            default:
              return 'gray';
          }
        };
  
        return (
          <Box display="flex" alignItems="center" >
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                backgroundColor: getStatusColor(params.value),
                marginRight: 1,
              }}
            />
            <Typography>{params.value}</Typography>
          </Box>
        );
      },
    },
    {
      field: "cutOffDate",
      headerName: "CUT OFF",
      headerClassName: (params) =>
        params.field === "cutOffDate" ? "bold-header-style" : null,
      flex: 0.5,
      headerAlign: "left",
    },
    {
      field: "payOutDate",
      headerName: "PAYOUT BY",
      headerClassName: (params) =>
        params.field === "payOutDate" ? "bold-header-style" : null,
      flex: 0.5,
      headerAlign: "left",
    },
    {
      field: "summaryAmount",
      headerName: "PAYOUT",
      flex: 0.5,
      headerClassName: (params) =>
        params.field === "summaryAmount" ? "bold-header-style" : null,
      headerAlign: "left",
      cellClassName: "bold-column--cell",
      renderCell: (params) => <CurrencyCellRenderer value={params.value} />,
      sortable: false,
    }, 
    {
      field: "actions",
      headerName: "ACTIONS",
      flex: 0.5,
      renderCell: (params) => (
        <MoreOptionsButton row={params.row.batchNo} />
      ),
    },
  ];
  const downloadPreviedFile = () => {};
  function showErrorAlert(title, content) {
    try {
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }
  const openAttachment = (referenceId, attachmentType) => {
    let requestData;
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(PROCESSING_PLEASE_WAIT);
        setLoading(true); // Hide the progress dialog

        if (
          attachmentType !== null &&
          attachmentType !== undefined &&
          attachmentType !== ""
        ) {
          requestData = {
            attachmentType: attachmentType,
            referenceId: referenceId,
          };
        } else {
          requestData = {
            attachmentType: "FREEZE_ACCOUNTS",
            referenceId: referenceId,
          };
        }

        initializeEncryption(
          requestData,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.EXCLUSION_FILE_READ
        ).then((encryptedContentData) => {
          const addExclusionRequestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            contentData: encryptedContentData,
            loginUserName: getFromLocalStorage(USER_NAME),
          };

          downloadPdfViewerData(addExclusionRequestData)
            .then((response) => {
              // Determine the content type from the headers
              const contentType = response.headers["content-type"];
              const mimeType = contentType.split(";")[0];
              const type = contentType.split("/")[1];

              // Handle different content types
              if (mimeType.includes("application/json")) {
                const arrayBuffer = response.data;

                // Function to convert ArrayBuffer to JSON
                const arrayBufferToJson = (buffer) => {
                  const decoder = new TextDecoder("utf-8");
                  const jsonString = decoder.decode(buffer);
                  return JSON.parse(jsonString);
                };

                // Convert the ArrayBuffer to JSON and set it in state
                const jsonObject = arrayBufferToJson(arrayBuffer);

                if (jsonObject !== null && jsonObject.responseCode === "-1") {
                  if (
                    jsonObject.displayErrorMessage !== null &&
                    jsonObject.displayErrorMessage !== ""
                  ) {
                    showErrorAlert(ERROR, jsonObject.displayErrorMessage);
                  } else {
                    showErrorAlert(ERROR, jsonObject.errorDescription);
                  }
                }
              } else {
                let fileBlob;
                switch (mimeType) {
                  case "image/png":
                    blob = new Blob([response.data], { type: "image/png" });
                    filename = referenceId + ".png";

                    url = URL.createObjectURL(blob);
                    setPdfData(null);
                    setImageUrl(url);
                    setOpen(true);

                    // fileBlob = new Blob([blob], { type: "image/png" });
                    // FileSaver.saveAs(fileBlob, filename);
                    break;

                  case "image/jpeg":
                    blob = new Blob([response.data], { type: "image/jpeg" });
                    filename = referenceId + ".jpeg";

                    url = URL.createObjectURL(blob);
                    setPdfData(null);
                    setImageUrl(url);
                    setOpen(true);

                    // fileBlob = new Blob([blob], { type: "image/jpeg" });
                    // FileSaver.saveAs(fileBlob, filename);
                    break;

                  case "image/jpg":
                    blob = new Blob([response.data], { type: "image/jpg" });
                    filename = referenceId + ".jpg";
                    url = URL.createObjectURL(blob);
                    setPdfData(null);
                    setImageUrl(url);
                    setOpen(true);
                    // fileBlob = new Blob([blob], { type: "image/jpg" });
                    // FileSaver.saveAs(fileBlob, filename);
                    break;

                  case "application/pdf":
                    blob = new Blob([response.data], {
                      type: "application/pdf",
                    });
                    filename = referenceId + ".pdf";
                    url = URL.createObjectURL(blob);
                    setImageUrl(null);
                    setPdfData(url);
                    setOpen(true);
                    break;

                  default:
                    break;
                }

                if (
                  mimeType !== "application/pdf" &&
                  mimeType !== "image/jpg" &&
                  mimeType !== "image/jpeg" &&
                  mimeType !== "image/png"
                ) {
                  showErrorAlert(ALERT, "File type is not supported!");
                }
              }
              setLoading(false);
            })
            .catch((error) => {
              setLoading(false);
              if (
                error !== null &&
                error !== undefined &&
                error.data !== null &&
                error.data !== undefined &&
                error.data.errorCode != null &&
                error.data.errorCode !== undefined &&
                error.data.errorCode === ApiErrorCode.SESSION_EXPIRED
              ) {
                navigate(CONSTANT.LOGIN);
              } else if (
                error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND
              ) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.data != null
                    ? error.data.displayErrorMessage
                    : "Unknown";

                if (message)
                  showErrorAlert(
                    error.message,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_FOUND_DURING_API_CALL + JSON.stringify(message)
      );
    }
  };

  const handleClose = () => {
    setOpen(false);
    setFileDialogOpen(false);
  };
  return (
    /* Main Container */
    <Box>
      <SnackbarProvider maxSnack={3}>
        <ConnectionStatus />
        <ShowErrorAlertDialog
          status={getDialogStatus}
          title={title}
          content={content}
        />
         <FileDialog
    open={openFileDialog}
    onClose={handleClose}
    files={files}
    previewFile={openAttachment}
    type={"ON_HOLD_AND_PAYOUT_SERVICE"}
  />
  <PdfViewerDialog
    open={open}
    handleClose={handleClose}
    downloadPdf={downloadPreviedFile}
    pdfUrl={pdfData}
    imageUrl={imageUrl}
    comment={commentData}
  ></PdfViewerDialog>
         <DownloadPayoutOnHoldReportNameSelectionDialog
            open={downloadFileDialogOpen}
            handleClose={handleFileDownloadDialogClose}
            handleSubmit={handleFileDownloadSubmit}
            batchNo={batchNo}
            type={clickedButtonType}
            title={dialogTitle}
            reportNameOption={reportNameOptions}
            reportNamesList={reportNamesValue}
          />
        {isNetworkConnectionAvailable ? (
          <CustomProgressDialog open={loading} text={getProgressbarText} />
        ) : (
          showNoInternetSnackBar()
        )}

        {/* Header */}
        <Grid container direction={"row"} alignItems={"center"} mb={2} ml={2}>
          <Grid item mr={2}>
          <IconButton onClick={handleBackClicked} width={12}>
              <img src={"../../assets/common/Back.svg"} width={12} />
            </IconButton>
          </Grid>
          <Grid item>
            <Typography
              color={colors.grey[100]}
              fontWeight={"600"}
              variant="h3"
            >
              {holdType}
            </Typography>
          </Grid>
        </Grid>
        {/* Header */}

        {/* Highlights Section */}

        <HighlightStats
          highlightTotal={"RM " + formatPrice(onHoldHeaderSummary.totalAmount)}
          highlight1={"Device Reimbursement"}
          highlight1Stat={"RM " + formatPrice(onHoldHeaderSummary.deviceAmount)}
          highlight2={"Incentives"}
          highlight2Stat={
            "RM " + formatPrice(onHoldHeaderSummary.incentiveAmount)
          }
        ></HighlightStats>
        {/* Highlight Stats */}

        {/* Highlights Section */}

        <Grid
          container
          component="main"
          direction={"column"}
          sx={{
            // height: "100vh",
            m: "0 2.5%" /* Approx 30px */,
            borderRadius: "18px",
          }}
        >
          {/* Validations Section */}
          <Grid
            container
            mt={3}
            border={"1px solid" + colors.grey[600]}
            borderRadius={2}
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            pb={0}
          >
            <SectionHeader
              sectionIcon={
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.975 28.665V7.335C15.975 5.31 15.12 4.5 12.96 4.5H7.515C5.355 4.5 4.5 5.31 4.5 7.335V28.665C4.5 30.69 5.355 31.5 7.515 31.5H12.96C15.12 31.5 15.975 30.69 15.975 28.665Z"
                    stroke="#292D32"
                    stroke-width="2.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M31.4987 28.665V7.335C31.4987 5.31 30.6437 4.5 28.4837 4.5H23.0387C20.8937 4.5 20.0237 5.31 20.0237 7.335V28.665C20.0237 30.69 20.8787 31.5 23.0387 31.5H28.4837C30.6437 31.5 31.4987 30.69 31.4987 28.665Z"
                    stroke="#292D32"
                    stroke-width="2.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              }
              sectionHeading={"Cycles"}
              isSearchBarEnabled={true}
              filterProps={filterProps}
              onSearch={handleSearch}
            ></SectionHeader>

            {/* <SimpleTablesrc/assets/common/OnHold.svg
          statusData={"In Validation"}
          statusBG={colors.primary[300]}
          data={payoutSummary}
        ></SimpleTablesrc> */}

            {onHoldSummary.length > 0 ? (
              <Box
                borderRadius={3}
                flex={1}
                m="0px 0 0 0"
                pb={0}
                height={gridHeight}
                sx={{
                  "& .MuiDataGrid-root": {
                    border: "none",
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "none",
                  },
                  "& .name-column--cell": {
                    color: colors.redAccent[600],
                    fontWeight: "bold",
                    fontSize: 13,
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "rgba(255,255,255,0.6)",
                    borderBottom: "none",
                    fontWeight: "bold",
                    fontSize: "13px",
                    color: `${colors.grey[300]} !important`,
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    background: "rgba(255,255,255,1)",
                  },
                  "& .MuiDataGrid-footerContainer": {
                    borderTop: "none",
                    backgroundColor: "rgba(255,255,255,0.6)",
                  },
                  "& .MuiCheckbox-root": {
                    //color: `${colors.white[200]} !important`,
                  },
                  "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                    color: `${colors.grey[300]} !important`,
                    // backgroundColor: "rgba(255,255,255,0.6)",
                    // opacity:.5
                  },
                }}
              >
                <DataGrid
                  classes={{ row: "dataGridRow" }}
                  rows={onHoldSummary}
                  columns={onHoldPayoutCyclesColumnHeader}
                  checkboxSelection
                  selectionModel={selectedRows}
                  onSelectionModelChange={handleSelectionChange}
                  disableSelectionOnClick // Disable row selection on row click
                  pageSize={pageSize}
                  rowCount={totalNoOfRows}
                  paginationModel={paginationModel}
                  paginationMode="server"
                  keepNonExistentRowsSelected
                  onPageChange={handlePageChange}
                  onPageSizeChange={handlePageSizeChange}
                  rowsPerPageOptions={[15, 30, 45, 60]}
                  // useResizeContainer
                  //           columnBuffer={2} // Adjusts the number of columns rendered outside the viewport
                  // autoPageSize // Automatically adjusts the page size based on the available height
                  autoHeight // Adjusts the height of the grid to fit its content
                  //onRowClick={handleRowClick}
                  onCellClick={handleRowClick}
                  sortModel={sortModel}
                  onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
                />
              </Box>
            ) : (
              NoDataFound()
            )}
          </Grid>

          {onHoldSummary.length > 0 ? (
            <Box item mt={6}>
              <Typography>
                <span>Jump to page: </span>
                <select
                  value={paginationModel.page + 1}
                  onChange={handlePageJump}
                >
                  {[...Array(totalNoOfPages)].map((_, index) => (
                    <option key={index} value={index + 1}>
                      {index + 1}
                    </option>
                  ))}
                </select>
              </Typography>
            </Box>
          ) : (
            ""
          )}

          {/* Validations Section */}
        </Grid>

        {/* Confirmation Dialog */}
        <IncentivesActionsConfirmationDialog
          open={dialogOpen}
          handleClose={handleDialogClose}
          handleSubmit={handleSubmit}
          type={clickedButtonType}
          title={dialogTitle}
        />
        {/* Confirmation Dialog */}

        {/* Action Buttons */}

        {onHoldSummary.length > 0 ? (
          <Grid item mt={1} justifyContent={"flex-start"} pb={20} mr={10}>
            <Stack direction="row" spacing={2} justifyContent={"flex-end"}>
              {requestReleaseButtonVisible && actionButtonVisibility? (
                <CustomButton
                  btnBG={colors.grey[900]}
                  btnColor={colors.grey[100]}
                  // btnStartIcon={
                  //   <img src="../../assets/common/Cross.svg" width={22} />
                  // }
                  btnTxt={"Request Release"}
                  onClick={() => handleDialogOpen("Request Release")}
                ></CustomButton>
              ) : (
                ""
              )}
              
              {cancelButtonButtonVisibility && actionButtonVisibility ? (
                <CustomButton
                  btnBG={colors.grey[900]}
                  btnColor={colors.grey[100]}
                  btnStartIcon={
                    <img src="../../assets/common/Cross.svg" width={22} />
                  }
                  btnTxt={"Cancel"}
                  onClick={() => handleDialogOpen("Cancel")}
                ></CustomButton>
              ) : (
                ""
              )}
              {rejectButtonVisibility && actionButtonVisibility ? (
                  <CustomButton
                    btnBG={colors.grey[900]}
                    btnColor={colors.grey[100]}
                    btnStartIcon={
                      <img src="../../assets/common/Tick.svg" width={22} />
                    }
                    btnTxt={"Reject"}
                    onClick={() => handleDialogOpen("Reject")}
                  ></CustomButton>
                ) : (
                  ""
                )}
              {releaseButtonVisibility  && actionButtonVisibility ? (
                <CustomButton
                  btnBG={colors.grey[900]}
                  btnColor={colors.grey[100]}
                  btnStartIcon={
                    <img src="../../assets/common/Tick.svg" width={22} />
                  }
                  btnTxt={"Release"}
                  onClick={() => handleDialogOpen("Release")}
                ></CustomButton>
              ) : (
                ""
              )}

              {/* {downloadButtonVisible ? (
                <DownloadDropdownButton
                  onFileTypeSelected={downloadOnHoldDetails}
                />
              ) : (
                ""
              )} */}
               {downloadButtonVisible ? (
                  <CustomButton
                    btnBG={colors.grey[900]}
                    btnColor={colors.grey[100]}
                    btnStartIcon={
                      <img src="../../assets/common/Download.svg" width={22} />
                    }
                    btnTxt={"Download"}
                    onClick={() => getReportName("Download")}
                  ></CustomButton>
                ) : (
                  ""
                )}
            </Stack>
          </Grid>
        ) : (
          ""
        )}

        {/* Action Buttons */}
      </SnackbarProvider>
    </Box>
    /* Main Container */
  );
};

export default OnHoldPayoutCycles;
